import { Component, Input, EventEmitter, Output, OnInit, OnDestroy, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { Label } from 'globals/store/events.data';
import { JoiInputComponent } from 'src/app/components/joi-input/joi-input.component';
import { LabelType } from '../../services/ui.service';
import { MAX_ENTITY_STARS } from 'globals/helpers/constants';
import { BigDialogWrapperComponent } from 'src/app/components/wrappers/big-dialog-wrapper.component';
import { IconComponent } from 'src/app/components/icon/icon.component';
import { CommonModule } from '@angular/common';
import { ToggleTabComponent } from 'src/app/components/buttons/toggle-tab.component';
import { StarsComponent } from 'src/app/components/misc/stars.component';
import { MobileLinkCardComponent } from 'src/app/components/cards/mobile-link-card.component';
import { LabelsRowComponent } from 'src/app/components/label-marker/labels-row';

@Component({
    selector: 'manage-wrapper',
    templateUrl: './manage-wrapper.html',
    styleUrls: ['manage-wrapper.scss'],
    standalone: true,
    imports: [BigDialogWrapperComponent, IconComponent, JoiInputComponent, CommonModule, ToggleTabComponent, StarsComponent, MobileLinkCardComponent, LabelsRowComponent ]
})
export class ManageWrapperComponent implements OnInit, OnDestroy, AfterViewInit {
  @Input() successLabel = 'DONE'
  @Input() dialogTitle = ''
  @Input() readOnly = false
  @Input() canEditMain = false
  @Input() topToggleText = ''
  @Input() topToggled = false
  @Input() topSecondToggleText = ''
  @Input() topSecondToggled = false
  @Input() entityTitle = ''
  // @Input() emptyEntityTitleText = ''
  @Input() tabGroups: TabGroup[] = []
  @Input() selectedTab: Tab
  @Input() backgroundColor
  @Input() labels: string[]
  @Input() labelMap: { [id:string]: Label }
  @Input() labelList: Label[]
  @Input() labelUpdateFunction
  @Input() type: LabelType = 'session'
  @Input() dateLine = ''
  @Input() focusTitle = false
  @Input() deleteTitle = ''
  @Input() deleteText = ''
  @Input() whiteTitle = false
  @Input() canDuplicate = true
  @Input() titlePlaceholder = 'Click to add a title...'
  @Input() showCheck = false
  @Input() checked = false
  @Input() fullHeight = false // for manage-inner-panel
  @Input() midRightLabel: string = null
  @Input() clipLabel: string = null
  @Input() hideLabels = false
  @Input() noTabs = false
  @Input() showStars = false
  @Input() stars = 0
  @Input() hideTop = false
  @Input() hideDelete = false
  MAX_ENTITY_STARS = MAX_ENTITY_STARS

  @Output() saveStars: EventEmitter<number> = new EventEmitter()
  @Output() onMidRight: EventEmitter<void> = new EventEmitter()
  @Output() onCheck: EventEmitter<void> = new EventEmitter()
  @Output() onDone: EventEmitter<void> = new EventEmitter()
  @Output() onDelete: EventEmitter<void> = new EventEmitter()
  @Output() onToggle: EventEmitter<void> = new EventEmitter()
  @Output() onSecondToggle: EventEmitter<void> = new EventEmitter()
  @Output() onDuplicate: EventEmitter<void> = new EventEmitter()
  @Output() onClip: EventEmitter<void> = new EventEmitter()
  @Output() onChangeTab: EventEmitter<Tab> = new EventEmitter()
  @Output() saveTitle: EventEmitter<string> = new EventEmitter()
  @Output() manageLabels: EventEmitter<any>  = new EventEmitter()


  observer: IntersectionObserver
  @ViewChild('stickyTab', { static: true }) stickyTab: ElementRef;
  @ViewChild('manageTitle') manageTitle: JoiInputComponent

  minHeight = 80

  ngOnInit() {
    this.minHeight = !this.tabGroups.length ? 0 : this.tabGroups.reduce((acc, group) => acc + (group.groupName ? 31 : 0) + group.tabs.length*40, 40) 
      - (this.tabGroups[0].groupName ? 31 : 0)
  }

  ngAfterViewInit() {
    this.observer = new IntersectionObserver( 
      ([e]) => e.target.classList.toggle('stickied', e.intersectionRatio < 1),
      {threshold: [1]}
    );
    this.observer.observe(this.stickyTab.nativeElement)
    if (this.focusTitle) setTimeout(() => this.manageTitle.manualFocus(), 500) // without the delay sometimes other things get focused, I don't know why
  }

  emitSaveTitle(title: string) {
    this.saveTitle.emit(title)
  }

  ngOnDestroy() {
    this.observer.disconnect()
  }

}


export interface Tab<T = string> { id: T, name: string, unseenComments?: number, icon?: string }
export interface TabGroup<T = string> { groupName?: string, tabs: Tab<T>[] }